import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";

// Image
import { QuickActionCustomIcon, QuickActionSendIcon, QuickActionComposeIcon } from "../icons";

type Props = {
  type: "compose" | "custom" | "send";
  onClick?: () => void;
  invisibleTitle?: boolean;
  disabled?: boolean;
};

const content = {
  compose: {
    image: <QuickActionComposeIcon />,
    title: "Compose Email",
  },
  custom: {
    image: <QuickActionCustomIcon />,
    title: "Custom Product",
  },
  send: {
    image: <QuickActionSendIcon />,
    title: "Send Invoice",
  },
};

const bem = new BemHelper("quick-actions");

export const QuickActions: React.FC<Props> = ({
  type,
  onClick,
  invisibleTitle = false,
  disabled = false,
}) => {
  const data = content[type];

  return (
    <div
      className={classNames(bem.block(), disabled && bem.modifier("disabled"))}
      onClick={() => {
        if (typeof onClick === "function") onClick();
      }}
    >
      <div className={classNames(bem.element("image"))}>{data.image}</div>
      {!invisibleTitle && <div className={classNames(bem.element("link"))}>{data.title}</div>}
    </div>
  );
};
